import * as Icons from '@mui/icons-material'; // Importáljuk az összes ikont

const getIconComponent = (icon) => {
  const IconComponent = Icons[icon];
  return IconComponent ? <IconComponent sx={{ fontSize: 60 }} /> : null;
};

export default getIconComponent;
